<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="18" height="13" rx="2" stroke="white" stroke-width="2"/>
    <path d="M1.5 2.30762L8.80348 7.76045C9.51317 8.2903 10.4868 8.2903 11.1965 7.76044L18.5 2.30762" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>